
import React from "react";
import { reverseEnum, OperationType, SurgerySide, ValueMappings } from "../../enum.js";
import { formatDate, roundPriorityScore } from "../../util.js";

const EditingButton = ({ 
  operationDetails, 
  editedOperation, 
  handleEditChange, 
  isEditing 
}) => {
  return (
    <tr>
      {/* Surgeon ID */}
      <td>
        {isEditing ? (
          <input
            type="text"
            name="surgeonId"
            value={editedOperation?.surgeonId ?? operationDetails?.surgeonId ?? ""}
            onChange={handleEditChange}
          />
        ) : (
          operationDetails.surgeonId || "N/A"
        )}
      </td>

      {/* Operation Type */}
      <td>
        {isEditing ? (
          <select 
            name="operationType" 
            value={editedOperation?.operationType ?? reverseEnum(OperationType)?.[operationDetails?.operationType] ?? ""}
            onChange={handleEditChange}
          >
            <option value="HipReplacement">Hip Replacement</option>
            <option value="KneeReplacement">Knee Replacement</option>
          </select>
        ) : (
          ValueMappings.operationType[operationDetails.operationType] || "N/A"
        )}
      </td>

      {/* Surgery Side */}
      <td>
        {isEditing ? (
          <select 
            name="surgerySide" 
            value={editedOperation?.surgerySide ?? reverseEnum(SurgerySide)?.[operationDetails?.surgerySide] ?? ""}
            onChange={handleEditChange}
          >
            <option value="L">Left</option>
            <option value="R">Right</option>
          </select>
        ) : (
          ValueMappings.surgerySide[operationDetails.surgerySide] || "N/A"
        )}
      </td>

      {/* Preassessment Status */}
      <td>
        {isEditing ? (
          <select
            name="preassessmentPassed"
            value={editedOperation?.preassessmentPassed ?? operationDetails?.preassessmentPassed ? "true" : "false"}
            onChange={(e) =>
              handleEditChange({
                target: {
                  name: "preassessmentPassed",
                  value: e.target.value === "true"
                }
              })
            }
          >
            <option value="true">Passed</option>
            <option value="false">Failed</option>
          </select>
        ) : operationDetails.preassessmentPassed ? "Passed" : "Failed"}
      </td>

      {/* Theatre Date */}
      <td>
        {isEditing ? (
          <input
            type="date"
            name="theatreDate"
            value={editedOperation?.theatreDate?.slice(0, 10) ?? operationDetails?.theatreDate?.slice(0, 10) ?? ""}
            onChange={handleEditChange}
          />
        ) : (
          formatDate(operationDetails?.theatreDate) ?? "N/A"
        )}
      </td>

      {/* Bed Required */}
      <td>
        {isEditing ? (
          <select
            name="bedRequired"
            value={editedOperation?.bedRequired ?? operationDetails?.bedRequired ? "true" : "false"}
            onChange={(e) =>
              handleEditChange({
                target: {
                  name: "bedRequired",
                  value: e.target.value === "true"
                }
              })
            }
          >
            <option value="true">✔</option>
            <option value="false">✗</option>
          </select>
        ) : (
          operationDetails.bedRequired ? "✔" : "✗"
        )}
      </td>     
                     
      {/* NTC Suitability */}
      <td>
        {isEditing ? (
          <select
            name="ntcSuitability"
            value={editedOperation?.ntcSuitability ?? operationDetails?.ntcSuitability ? "true" : "false"}
            onChange={(e) =>
              handleEditChange({
                target: {
                  name: "ntcSuitability",
                  value: e.target.value === "true"
                }
              })
            }
          >
            <option value="true">✔</option>
            <option value="false">✗</option>
          </select>
        ) : (
          operationDetails.ntcSuitability ? "✔" : "✗"
        )}
      </td>                    
      
      {/* Robotic Surgery */}
      <td>
        {isEditing ? (
          <select
            name="roboticSurgery"
            value={editedOperation?.roboticSurgery ?? operationDetails?.roboticSurgery ? "true" : "false"}
            onChange={(e) =>
              handleEditChange({
                target: {
                  name: "roboticSurgery",
                  value: e.target.value === "true"
                }
              })
            }
          >
            <option value="true">✔</option>
            <option value="false">✗</option>
          </select>
        ) : (
          operationDetails.roboticSurgery ? "✔" : "✗"
        )}
      </td>                    
      
      {/* Priority Score */}
      <td>
          {roundPriorityScore(operationDetails.priorityScore) || "N/A"}
      </td>
    </tr>
  );
};

export default EditingButton;